import { AuthXInterceptor } from '../Config/AuthXInterceptor'
import { AxiosInterceptor } from '../../Config/AxiosInterceptor'

AxiosInterceptor()

// const BASE_URL = process.env.REACT_APP_BX_BASE_URL || ''
// const token = process.env.REACT_APP_BX_TOKEN || ''

export type AdminUserDetail = {
  resourceId: string
  firstName: string
  lastName: string
  email: string
  accountType?: string
}

type AdminUserDetailResponse = {
  data: AdminUserDetail
}

export const userBXService = {
  index: async (page: number, limit: number, sortOrder: 'ASC' | 'DESC', additionalParams?: any) => {
    const params: any = {
      page,
      limit,
      sortOrder,
    }

    // Add additional parameters if provided
    if (additionalParams) {
      Object.assign(params, additionalParams)
    }

    return await AuthXInterceptor.get('users', {
      params,
      //   headers: {
      //     accept: 'application/json',
      //     Authorization: `Bearer ${token}`,
      //   },
    })
  },

  show: async (userId: string) => {
    return AuthXInterceptor.get<AdminUserDetailResponse>(
      `users/${encodeURIComponent(userId)}`,
    )
  },

  disable: async (userId: string) => {
    return await AuthXInterceptor.put(
      `users/${userId}/disable`,
      //   , {
      //   headers: {
      //     accept: 'application/json',
      //     Authorization: `Bearer ${token}`,
      //   },
      // }
    )
  },

  enable: async (userId: string) => {
    return await AuthXInterceptor.put(`users/${userId}/enable`)
  },

  virtualAccount: async (userId: string) => {
    return await AuthXInterceptor.get(`users/${userId}/virtual-account`)
  },

  csvExport: async (params?: any) => {
    return await AuthXInterceptor.get('users/csv', {
      params,
      responseType: 'blob',
    })
  },

  fundWallet: async (userId: string, data: { amountMajor: number; description: string; reference: string }) => {
    return await AuthXInterceptor.post(`users/${userId}/fund-wallet`, data)
  },
}
